import $ from 'jquery';
import { editorConfig } from '~config';
import { setSvgColor } from '~src/ui';

export const onShadowRemove = (event) => {
  event.preventDefault();
  if (!window.canvas.getActiveObject()) {
    return;
  }
  $('#editor-menu-remove-shadow').attr('disabled', true);
  setSvgColor('#img-shadow-object', editorConfig.styles.inactiveControlColor);
  window.canvas.getActiveObject().set('shadow', null);
  window.canvas.renderAll();
};
